import moment from 'moment'

class VueMoment  {
 install(Vue,locale) {
   moment.locale(locale)
   Vue.prototype.$moment = moment
}

}
export default new VueMoment
